import { render, staticRenderFns } from "./ChatRoot.vue?vue&type=template&id=1d093143&scoped=true"
import script from "./ChatRoot.vue?vue&type=script&lang=js"
export * from "./ChatRoot.vue?vue&type=script&lang=js"
import style0 from "./ChatRoot.vue?vue&type=style&index=0&id=1d093143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d093143",
  null
  
)

export default component.exports